import type { ButtonProps } from '@chakra-ui/react'
import { Button } from '@chakra-ui/react'
import { BgColors, TextColors } from 'commons/design-system/tokens'
import type { PropsWithChildren } from 'react'

export const RoundButton = ({ children, ...props }: PropsWithChildren<ButtonProps>) => {
	return (
		<Button
			cursor='pointer'
			borderRadius='full'
			fontFamily='Montserrat'
			fontSize='14px'
			lineHeight='21px'
			fontWeight={700}
			h='full'
			bg={BgColors.Z4}
			color={TextColors.TERTIARY}
			transition='0.22s ease-out background-color'
			_hover={{ bg: BgColors.Z2 }}
			_checked={{
				bg: BgColors.STATUS_INFO,
				color: BgColors.OPPOSITE_Z3,
				outline: '2px solid',
				outlineColor: BgColors.OPPOSITE_Z3,
				outlineOffset: '-2px'
			}}
			_focus={{
				outline: '2px solid',
				outlineColor: BgColors.OPPOSITE_Z3,
				outlineOffset: '-2px',
				boxShadow: 'none'
			}}
			_focusVisible={{
				outline: '2px solid',
				outlineColor: BgColors.OPPOSITE_Z3,
				outlineOffset: '-2px',
				boxShadow: 'none'
			}}
			px={5}
			py={3}
			{...props}
		>
			{children}
		</Button>
	)
}
